import ApiService from './ApiService';

export async function apiGetCrmDashboardData(data) {
  return ApiService.fetchData({
    url: '/crm/dashboard',
    method: 'get',
    data,
  });
}

export async function apiGetCrmCalendar() {
  return ApiService.fetchData({
    url: '/crm/calendar',
    method: 'get',
  });
}

export async function apiGetCrmCustomers(data) {
  const response = await ApiService.fetchData({
    url: 'http://localhost:5000/userData',
    method: 'get',
  });
  return response;
}

export async function apiGetCrmCustomersStatistic(params) {
  const response = await ApiService.fetchData({
    url: 'http://localhost:5000/customerStatistic',
    method: 'get',
  });

  return response;
}

export async function apPutCrmCustomer(data) {
  return ApiService.fetchData({
    url: '/crm/customers',
    method: 'put',
    data,
  });
}

export async function apiGetCrmCustomerDetails(params) {
  return ApiService.fetchData({
    url: '/crm/customer-details',
    method: 'get',
    params,
  });
}

export async function apiDeleteCrmCustomer(data) {
  return ApiService.fetchData({
    url: '/crm/customer/delete',
    method: 'delete',
    data,
  });
}

export async function apiGetorderManagements(params) {
  return ApiService.fetchData({
    url: '/crm/mails',
    method: 'get',
    params,
  });
}

export async function apiGetorderManagement(params) {
  return ApiService.fetchData({
    url: '/crm/mail',
    method: 'get',
    params,
  });
}
